import Vue from 'vue'
import countTo from 'vue-count-to'
import pageHeader from '@/components/pageHeader/pageHeader'
import comMenu from '@/components/comMenu/comMenu'
let component = {
    countTo,
    pageHeader,
    comMenu
}

function installCom () {
    for (let item in component) {
        Vue.component(item, component[item])
    }
}

installCom()



// WEBPACK FOOTER //
// ./src/utils/componentRegister.js